import React, { Component } from "react";

import "./SoundsPagination.component.scss";

export interface SoundsTableProps {
    rows: any;
    total: number;
    start: number;
    end: number;
    currentPage: number;
    pages: number;
    navigationAction: any;
    nextAction: any;
    previousAction: any;
}

class SoundsTable extends Component<SoundsTableProps, {}> {
    render() {
        return (
            <div className="table-navigation">
                <div>Items per page {this.props.rows.length}</div>
                <div className="pages">
                    {this.props.pages > 0 && (
                        <ul>
                            {/* Regular Pagination */}
                            {this.props.pages > 1 && (
                                <li
                                    className={`navigation-button ${
                                        this.props.currentPage === 0
                                            ? "hidden"
                                            : ""
                                    }`}
                                    onClick={this.props.previousAction}
                                    key="prev-button"
                                >
                                    <span className="material-icons">
                                        keyboard_arrow_left
                                    </span>
                                </li>
                            )}

                            {/* Pagination With Placeholders */}
                            {this.props.pages <= 8 &&
                                [...Array(this.props.pages)].map(
                                    (object, index) => {
                                        return (
                                            <li
                                                onClick={() =>
                                                    this.props.navigationAction(
                                                        index
                                                    )
                                                }
                                                className={
                                                    this.props.currentPage ==
                                                    index
                                                        ? `selected`
                                                        : ``
                                                }
                                                key={index}
                                            >
                                                {index + 1}
                                            </li>
                                        );
                                    }
                                )}
                            {this.props.pages > 8 && (
                                <React.Fragment>
                                    {[...Array(3)].map((object, index) => {
                                        return (
                                            <li
                                                onClick={() =>
                                                    this.props.navigationAction(
                                                        index
                                                    )
                                                }
                                                className={
                                                    this.props.currentPage ==
                                                    index
                                                        ? `selected`
                                                        : ``
                                                }
                                                key={index}
                                            >
                                                {index + 1}
                                            </li>
                                        );
                                    })}
                                    {this.props.currentPage > 3 &&
                                        this.props.currentPage <
                                            this.props.pages - 2 && (
                                            <span className="pages-placeholder">
                                                ...
                                            </span>
                                        )}
                                    {this.props.currentPage >= 3 &&
                                        this.props.currentPage <
                                            this.props.pages - 2 && (
                                            <li
                                                className="selected"
                                                key={this.props.currentPage + 1}
                                            >
                                                {this.props.currentPage + 1}
                                            </li>
                                        )}
                                    <span className="pages-placeholder">
                                        ...
                                    </span>
                                    {this.props.currentPage ===
                                        this.props.pages - 2 && (
                                        <li
                                            onClick={() =>
                                                this.props.navigationAction(
                                                    this.props.pages - 2
                                                )
                                            }
                                            className={
                                                this.props.currentPage ==
                                                this.props.pages - 2
                                                    ? `selected`
                                                    : ``
                                            }
                                            key={this.props.pages - 2}
                                        >
                                            {this.props.pages - 1}
                                        </li>
                                    )}
                                    <li
                                        onClick={() =>
                                            this.props.navigationAction(
                                                this.props.pages - 1
                                            )
                                        }
                                        className={
                                            this.props.currentPage ==
                                            this.props.pages - 1
                                                ? `selected`
                                                : ``
                                        }
                                        key={this.props.pages - 1}
                                    >
                                        {this.props.pages}
                                    </li>
                                </React.Fragment>
                            )}
                            {this.props.pages > 1 && (
                                <li
                                    className={`navigation-button ${
                                        this.props.currentPage ===
                                        this.props.pages - 1
                                            ? "hidden"
                                            : ""
                                    }`}
                                    onClick={this.props.nextAction}
                                    key="next-button"
                                >
                                    <span className="material-icons">
                                        keyboard_arrow_right
                                    </span>
                                </li>
                            )}
                        </ul>
                    )}
                </div>
                <div>
                    {this.props.start} - {this.props.end} of {this.props.total}
                </div>
            </div>
        );
    }
}

export default SoundsTable;
